import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { AlloyGatorSection } from './components/AlloyGatorSection';
import { HighlightSection } from './components/HighlightSection';
import { USPSection } from './components/USPSection';
import { PortfolioSection } from './components/PortfolioSection';
import { ReviewsSection } from './components/ReviewsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { FixedCTA } from './components/FixedCTA';
import { DemoIndicator } from './components/DemoIndicator';
import { PageTransition } from './components/PageTransition';
import { HelmetProvider } from 'react-helmet-async';
import { Breadcrumbs } from './components/Breadcrumbs';
// Pages
import { HomePage } from './pages/HomePage';
import { DienstenPage } from './pages/DienstenPage';
import { FaqPage } from './pages/FaqPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { OverOnsPage } from './pages/OverOnsPage';
import { LichtenSmokenPage } from './pages/diensten/LichtenSmokenPage';
import { OntchromenPage } from './pages/diensten/OntchromenPage';
import { RamenTintingPage } from './pages/diensten/RamenTintingPage';
import { AlloyGatorPage } from './pages/diensten/AlloyGatorPage';
import { AutoWrappenPage } from './pages/diensten/AutoWrappenPage';
import { ContactPage } from './pages/ContactPage';
import { AfspraakMakenPage } from './pages/AfspraakMakenPage';
import { MaatwerkAdviesPage } from './pages/diensten/MaatwerkAdviesPage';
export function App() {
  return <HelmetProvider data-id="element-0">
      <Router data-id="element-1">
        <div className="bg-[#0a0a0a] text-white min-h-screen" data-id="element-2">
          <Navbar data-id="element-3" />
          <Breadcrumbs data-id="element-4" />
          <PageTransition data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<HomePage data-id="element-8" />} data-id="element-7" />
              <Route path="/diensten" element={<DienstenPage data-id="element-10" />} data-id="element-9" />
              <Route path="/veelgestelde-vragen-faq" element={<FaqPage data-id="element-12" />} data-id="element-11" />
              <Route path="/privacybeleid" element={<PrivacyPage data-id="element-14" />} data-id="element-13" />
              <Route path="/algemene-voorwaarden" element={<TermsPage data-id="element-16" />} data-id="element-15" />
              <Route path="/over-ons" element={<OverOnsPage data-id="element-18" />} data-id="element-17" />
              <Route path="/diensten/lichten-smoken" element={<LichtenSmokenPage data-id="element-20" />} data-id="element-19" />
              <Route path="/diensten/ontchromen" element={<OntchromenPage data-id="element-22" />} data-id="element-21" />
              <Route path="/diensten/ramen-tinting" element={<RamenTintingPage data-id="element-24" />} data-id="element-23" />
              <Route path="/diensten/alloygator" element={<AlloyGatorPage data-id="element-26" />} data-id="element-25" />
              <Route path="/diensten/autowrappen" element={<AutoWrappenPage data-id="element-28" />} data-id="element-27" />
              <Route path="/diensten/maatwerk-advies" element={<MaatwerkAdviesPage data-id="element-30" />} data-id="element-29" />
              <Route path="/contact" element={<ContactPage data-id="element-32" />} data-id="element-31" />
              <Route path="/afspraak-maken" element={<AfspraakMakenPage data-id="element-34" />} data-id="element-33" />
            </Routes>
          </PageTransition>
          <Footer data-id="element-35" />
          <FixedCTA data-id="element-36" />
          <DemoIndicator data-id="element-37" />
        </div>
      </Router>
    </HelmetProvider>;
}